import { ROLE_LABELS } from '@company/shared'
import { Link } from '@tanstack/react-router'
import { LogOut, User } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { ThemeSwitcher } from '@/components/ui/theme-switcher'
import { useCurrentUser, useLogout , useSearchDialog } from '@/hooks'

import { NotificationBell } from './notification-bell'
import { SearchDialog } from './search-dialog'
import { SearchTrigger } from './search-trigger'

/**
 * 头部组件
 */
export function Header() {
  const { data: user } = useCurrentUser()
  const logout = useLogout()
  const { isOpen, open, close } = useSearchDialog()

  return (
    <header className="bg-card flex h-16 items-center justify-between border-b px-6">
      {/* 左侧 */}
      <div className="flex items-center gap-4">
        {/* 全局搜索 */}
        <SearchTrigger onClick={open} />
      </div>

      {/* 搜索对话框 */}
      <SearchDialog isOpen={isOpen} onClose={close} />

      {/* 右侧 */}
      <div className="flex items-center gap-4">
        {/* 通知铃铛 */}
        <NotificationBell />

        {/* 主题切换 */}
        <ThemeSwitcher />

        {/* 用户信息 - 点击跳转到个人资料 */}
        <Link
          to="/settings/profile"
          className="hover:bg-accent flex items-center gap-3 rounded-md px-2 py-1"
        >
          <div className="bg-primary text-primary-foreground flex h-8 w-8 items-center justify-center rounded-full">
            <User className="h-4 w-4" />
          </div>
          <div className="hidden md:block">
            <div className="text-sm font-medium">{user?.name}</div>
            <div className="text-muted-foreground text-xs">
              {user?.role ? ROLE_LABELS[user.role] : ''}
            </div>
          </div>
        </Link>

        {/* 登出按钮 */}

        <Button
          variant="ghost"
          size="icon"
          onClick={() => logout.mutate()}
          disabled={logout.isPending}
          aria-label="登出"
        >
          <LogOut className="h-5 w-5" />
        </Button>
      </div>
    </header>
  )
}
